import React from 'react'
import { useI18n } from '../i18n'
import { testChatNoticeCopy } from '../lib/testChatNotices'
import './TestChatNotice.css'

export default function TestChatNotice({ notice }) {
  const { lang } = useI18n()
  if (!notice) return null
  const copy = testChatNoticeCopy(notice, lang)
  const when = notice.created_at ? new Date(notice.created_at) : null
  const validTime = when && !Number.isNaN(when.getTime())
  return (
    <aside className={`test-chat-notice test-chat-notice--${notice.severity || 'warning'}`} role="status" aria-live="polite">
      <div className="test-chat-notice__meta">
        <span>{copy.system}</span>
        {validTime ? <time dateTime={notice.created_at}>{when.toLocaleString(lang === 'ru' ? 'ru-RU' : 'en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</time> : null}
      </div>
      <strong>{copy.title}</strong>
      {notice.active ? <span className="test-chat-notice__current">{copy.current}</span> : null}
      <p>{copy.detail}</p>
    </aside>
  )
}
